import React, { useState, useEffect } from "react";
import { A } from "@expo/html-elements";
import { ImageBackground, TouchableOpacity, View } from "react-native";
import VideoPlayer from "../../../components/VideoPlayer";
import THEME from "../../../config/theme";
import { ImageBlocked } from "../style";
import { borderRadiusButtons } from "../../../config/data";
import { useCustomTheme } from '../../../contexts/useCustomTheme';
import { useNavigation } from '@react-navigation/native';
import { StandardText } from "../../../config/theme/globalStyles";

const ViewVideo = (props) => {

  const navigation = useNavigation();

  const { video, user, card, cardId, categoryId, selectedVideo } = props;
  const { plans, coursesCard, img, backgroundImage, productIds } = card || {};
  const { meetingNumber, meetingPassword, title } = video || {};
  const { plan: userPlan, courses: userCourses, isAdmin } = user || {};

  const { customColor, customFont } = useCustomTheme();

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const image = backgroundImage?.url || img;
  const backgroundVideoImage = video?.backgroundImage?.url || '';
  const meetingUrl = "https://zoom.us/j/" + meetingNumber + "?pwd=" + meetingPassword;
  const src = video?.videoInfo?.url || video?.pandaVideoMetadata?.video_player || video?.link;

  const toDate = (seconds) => {
    const date = new Date(1970, 0, 1);
    date.setSeconds(seconds);
    return date;
  };

  const parseTimestamp = ts => {
    if (!ts) return null;
    if (typeof ts.toDate === 'function') {
      return ts.toDate();
    }
    return new Date(ts.seconds * 1000 + (ts.nanoseconds || 0) / 1e6);
  };

  useEffect(() => {
    const ts = video?.liveDate;
    if (!ts) return;   // sem liveDate, não inicializa

    const targetDate = parseTimestamp(ts);
    if (!targetDate) return;

    const tick = () => {
      const now = new Date();
      const diff = targetDate.getTime() - now.getTime();

      if (diff <= 0) {
        clearInterval(intervalId);
        return setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }

      setTimeLeft({
        days: Math.floor(diff / 86400000),
        hours: Math.floor((diff % 86400000) / 3600000),
        minutes: Math.floor((diff % 3600000) / 60000),
        seconds: Math.floor((diff % 60000) / 1000),
      });
    };

    tick();
    const intervalId = setInterval(tick, 1000);
    return () => clearInterval(intervalId);
  }, [video?.liveDate]);

  const content = (
    <>
      {(productIds &&
        productIds?.length > 0 &&
        productIds?.filter((cardProductId) => {
          const matchingUserProducts = user?.productIds?.filter(
            (userProduct) => userProduct.productId === cardProductId
          );
          if (!matchingUserProducts || matchingUserProducts.length === 0) {
            return false; // O usuário não possui este produto, então não tem acesso
          }
          // Se não houver data de expiração, ou se alguma data de expiração for maior que a data atual, o usuário tem acesso
          return matchingUserProducts.some(
            (userProduct) =>
              !userProduct.expirationDate ||
              toDate(userProduct.expirationDate.seconds) > new Date()
          );
        }).length > 0) ||
        (plans &&
          plans.length > 0 &&
          plans.filter((plan) => (plan.priceId || plan.productId) == userPlan)
            .length > 0) ||
        (userCourses &&
          userCourses.length > 0 &&
          userCourses.filter(
            (course) =>
              coursesCard?.some(
                (itemToBeRemoved) =>
                  (itemToBeRemoved.priceId || itemToBeRemoved.productId) ===
                  (course.priceId || course.productId)
              ) && toDate(course.dueDate.seconds) > new Date()
          ).length > 0) ||
        (plans == null && coursesCard == null && productIds == null) ||
        isAdmin === true ? (
        meetingNumber ? (
          <ImageBackground
            source={{ uri: backgroundVideoImage }}
            style={{
              resizeMode: 'cover',
              width: '100%',
              height: '100%',
            }}
          >
            <ImageBlocked>
              {video?.liveDate ? (
                <View
                  style={{
                    backgroundColor:
                      customColor?.background?.app ||
                      THEME?.COLORS?.BACKGROUND,
                    borderRadius: borderRadiusButtons,
                    padding: 16,
                    marginHorizontal: 16,
                    marginTop: 16,
                    alignSelf: 'center',
                    marginTop: 16,
                    // sombra iOS
                    shadowColor: '#000',
                    shadowOffset: { width: 0, height: 4 },
                    shadowOpacity: 0.1,
                    shadowRadius: 6,
                    // sombra Android
                    elevation: 4,
                  }}
                >
                  {/* Data e hora em pt-BR */}
                  <StandardText
                    style={{
                      textAlign: 'center',
                      marginBottom: 12,
                      color: customColor?.text?.app || THEME?.COLORS?.TEXT_MAIN
                    }}
                  >
                    {(() => {
                      const date = parseTimestamp(video?.liveDate);
                      return date
                        ? `${date?.toLocaleDateString('pt-BR')} às ${date?.toLocaleTimeString('pt-BR', {
                          hour: '2-digit',
                          minute: '2-digit',
                        })}`
                        : '';
                    })()}
                  </StandardText>

                  {/* Contador */}
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      marginBottom: 12,
                    }}
                  >
                    {[
                      { val: timeLeft.days, label: 'Dias' },
                      { val: timeLeft.hours, label: 'Horas' },
                      { val: timeLeft.minutes, label: 'Min' },
                      { val: timeLeft.seconds, label: 'Seg' },
                    ].map((item, idx) => (
                      <View key={idx} style={{ flex: 1, alignItems: 'center' }}>
                        <StandardText
                          style={{
                            fontSize: 32,
                            fontWeight: '700',
                            color: customColor?.primary || THEME?.COLORS?.PRIMARY_900,
                            marginBottom: 4,
                          }}
                        >
                          {item.val}
                        </StandardText>
                        <StandardText
                          style={{
                            fontSize: 12,
                            color: customColor?.text?.app || THEME?.COLORS?.TEXT_MAIN,
                          }}
                        >
                          {item.label}
                        </StandardText>
                      </View>
                    ))}
                  </View>
                  {/* Botão dentro do card */}
                  <TouchableOpacity
                    style={{
                      backgroundColor:
                        customColor && customColor?.button?.backgroundApp
                          ? customColor?.button?.backgroundApp
                          : THEME?.COLORS?.PRIMARY_900,
                      borderRadius: borderRadiusButtons,
                      padding: '0.7rem',
                      margin: '0.8rem',
                    }}
                  >
                    <A
                      href={meetingUrl}
                      style={{
                        fontSize:
                          customFont && customFont?.fontSM
                            ? customFont?.fontSM
                            : THEME?.FONTSIZE?.SMALL,
                        color:
                          customColor && customColor?.button
                            ? customColor?.button?.textApp
                            : THEME?.COLORS?.TEXT_BUTTON,
                        fontFamily:
                          customFont && customFont?.fontFamilySubtitle
                            ? customFont?.fontFamilySubtitle
                            : THEME?.FONTFAMILY?.BOLD,
                        textAlign: 'center',
                      }}
                    >{`Acessar ao vivo`}</A>
                  </TouchableOpacity>
                </View>
              ) : (
                <TouchableOpacity
                  style={{
                    backgroundColor:
                      customColor && customColor.button.backgroundApp
                        ? customColor.button.backgroundApp
                        : THEME.COLORS.PRIMARY_900,
                    borderRadius: borderRadiusButtons,
                    padding: '0.7rem',
                    margin: '0.8rem',
                  }}
                >
                  <A
                    href={meetingUrl}
                    style={{
                      fontSize:
                        customFont && customFont.fontSM
                          ? customFont.fontSM
                          : THEME.FONTSIZE.SMALL,
                      color:
                        customColor && customColor.button
                          ? customColor.button.textApp
                          : THEME.COLORS.TEXT_BUTTON,
                      fontFamily:
                        customFont && customFont.fontFamilySubtitle
                          ? customFont.fontFamilySubtitle
                          : THEME.FONTFAMILY.BOLD,
                      textAlign: 'center',
                    }}
                  >{`Acessar ao vivo`}</A>
                </TouchableOpacity>
              )}
            </ImageBlocked>
          </ImageBackground>
        ) : video?.type === 'livestream' ? (
          <ImageBackground
            source={{ uri: backgroundVideoImage }}
            style={{
              resizeMode: 'cover',
              width: '100%',
              height: '100%',
            }}
          >
            <ImageBlocked>
              {video?.liveDate ? (
                <View
                  style={{
                    backgroundColor:
                      customColor?.background?.app ||
                      THEME?.COLORS?.BACKGROUND,
                    borderRadius: borderRadiusButtons,
                    padding: 16,
                    marginHorizontal: 16,
                    marginTop: 16,
                    alignSelf: 'center',
                    marginTop: 16,
                    // sombra iOS
                    shadowColor: '#000',
                    shadowOffset: { width: 0, height: 4 },
                    shadowOpacity: 0.1,
                    shadowRadius: 6,
                    // sombra Android
                    elevation: 4,
                  }}
                >
                  {/* Data e hora em pt-BR */}
                  <StandardText
                    style={{
                      textAlign: 'center',
                      marginBottom: 12,
                      color: customColor?.text?.app || THEME?.COLORS?.TEXT_MAIN
                    }}
                  >
                    {(() => {
                      const date = parseTimestamp(video?.liveDate);
                      return date
                        ? `${date?.toLocaleDateString('pt-BR')} às ${date?.toLocaleTimeString('pt-BR', {
                          hour: '2-digit',
                          minute: '2-digit',
                        })}`
                        : '';
                    })()}
                  </StandardText>

                  {/* Contador */}
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      marginBottom: 12,
                    }}
                  >
                    {[
                      { val: timeLeft.days, label: 'Dias' },
                      { val: timeLeft.hours, label: 'Horas' },
                      { val: timeLeft.minutes, label: 'Min' },
                      { val: timeLeft.seconds, label: 'Seg' },
                    ].map((item, idx) => (
                      <View key={idx} style={{ flex: 1, alignItems: 'center' }}>
                        <StandardText
                          style={{
                            fontSize: 32,
                            fontWeight: '700',
                            color: customColor?.primary || THEME?.COLORS?.PRIMARY_900,
                            marginBottom: 4,
                          }}
                        >
                          {item.val}
                        </StandardText>
                        <StandardText
                          style={{
                            fontSize: 12,
                            color: customColor?.text?.app || THEME?.COLORS?.TEXT_MAIN,
                          }}
                        >
                          {item.label}
                        </StandardText>
                      </View>
                    ))}
                  </View>
                  {/* Botão dentro do card */}
                  <TouchableOpacity
                    style={{
                      backgroundColor:
                        customColor && customColor.button.backgroundApp
                          ? customColor.button.backgroundApp
                          : THEME.COLORS.PRIMARY_900,
                      borderRadius: borderRadiusButtons,
                      padding: '0.7rem',
                      margin: '0.8rem',
                    }}
                    onPress={() => {
                      navigation.navigate("Live", {
                        cardId: cardId,
                        categoryId: categoryId,
                        selectedVideo: selectedVideo
                      })
                    }}
                  >
                    <StandardText
                      color={
                        customColor && customColor.button
                          ? customColor.button.textApp
                          : THEME.COLORS.TEXT_BUTTON
                      }
                    >
                      {`Acessar ao vivo`}
                    </StandardText>
                  </TouchableOpacity>
                </View>
              ) : (
                <TouchableOpacity
                  style={{
                    backgroundColor:
                      customColor && customColor.button.backgroundApp
                        ? customColor.button.backgroundApp
                        : THEME.COLORS.PRIMARY_900,
                    borderRadius: borderRadiusButtons,
                    padding: '0.7rem',
                    margin: '0.8rem',
                  }}
                  onPress={() => {
                    navigation.navigate("Live", {
                      cardId: cardId,
                      categoryId: categoryId,
                      selectedVideo: selectedVideo
                    })
                  }}
                >
                  <StandardText
                    color={
                      customColor && customColor.button
                        ? customColor.button.textApp
                        : THEME.COLORS.TEXT_BUTTON
                    }
                  >
                    {`Acessar ao vivo`}
                  </StandardText>
                </TouchableOpacity>
              )
              }
            </ImageBlocked>
          </ImageBackground>
        ) : src ? (
          <VideoPlayer video={video} />
        ) : (
          <ImageBackground
            source={{
              uri: video?.backgroundImage?.url || video?.image || image,
            }}
            style={{
              resizeMode: 'cover',
              width: '100%',
              height: '100%',
            }}
          ></ImageBackground>
        )
      ) : (
        <></>
      )}
    </>
  );

  return (
    <View
      style={{
        width: "100%",
        height: "100%",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      {content}
    </View>
  );
};

export default ViewVideo;
